import { PropsWithChildren } from 'react';
import Slider from 'react-slick';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import './carousel.scss';

export const Carousel = (props: PropsWithChildren) => {
  return (
    <Slider
      dots
      dotsClass={clsx('button__bar', PaletteUtils.isVcfcPalette && 'vcfc')}
      infinite={false}
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      arrows={false}
    >
      {props.children}
    </Slider>
  );
};
